import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAttemptsLeft } from '../../../../redux-store/actions/link';
import { AdditionalDetails } from './AdditionalDetails';
import { ObjectiveDetails } from './ObjectiveDetails';
import { ProfileEvent, useProfileInfo } from './profile-context';
import { SubjectiveDetails } from './SubjectiveDetails';

export const AllDetails = ({ pan }: { pan: string }) => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    const reduxDispatch = useDispatch();
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        profileDispatch({
            action: ProfileEvent.SetDetailsType,
            payload: event.target.value as 'mainDetails' | 'additionalDetails',
        });
    };
    useEffect(() => {
        async function callAPI() {
            const {
                body: { attemptsLeft },
            } = await getAttemptsLeft({
                pan,
                pekrn: '',
            })(reduxDispatch);
            profileDispatch({
                action: ProfileEvent.SetAttemptsLeft,
                payload: attemptsLeft,
            });
        }
        callAPI();
    }, []);
    return (
        <>
            <ObjectiveDetails />
            <hr style={{ borderTop: '1px solid #DBD0EB', width: '100%', marginBottom: '10px' }} />
            <div style={{ width: '100%' }}>
                <SubjectiveDetails />
            </div>
            <hr style={{ borderTop: '1px solid #DBD0EB', width: '100%', marginBottom: '10px' }} />
            <AdditionalDetails />
        </>
    );
};
